<template>
  <div class="page-wrapper">
    <div class="content container-fluid">

      <div class="page-header">
        <div class="row">
          <div class="col-sm-12">
            <h3 class="page-title">Lịch sử Checklist</h3>
            <ul class="breadcrumb">
              <li class="breadcrumb-item"><router-link to="/">Dashboard</router-link></li>
              <li class="breadcrumb-item active">Lịch sử Checklist</li>
            </ul>
          </div>
        </div>
      </div>

      <div class="card mb-3">
        <div class="card-body">
          <form @submit.prevent="applyFilters" class="row g-3 align-items-end">
            <div class="col-md-4">
              <label class="form-label">Lọc theo Xe</label>
              <select v-model="filters.xeId" class="form-control" :disabled="isLoadingOptions">
                <option :value="null">-- Tất cả Xe --</option>
                <option v-for="opt in xeOptions" :key="opt.id" :value="opt.id">{{ opt.bienSo }}</option>
              </select>
            </div>
            <div class="col-md-4">
              <label class="form-label">Lọc theo Tài xế</label>
               <select v-model="filters.taiXeId" class="form-control" :disabled="isLoadingOptions">
                <option :value="null">-- Tất cả Tài xế --</option>
                 <option v-for="opt in taiXeOptions" :key="opt.id" :value="opt.id">{{ opt.hoTen }}</option>
              </select>
            </div>
             <div class="col-md-2">
              <label class="form-label">Kết quả</label>
              <select v-model="filters.hasError" class="form-control">
                <option :value="null">Tất cả</option>
                <option :value="true">Chỉ có Lỗi</option>
                <option :value="false">Chỉ OK</option>
              </select>
            </div>
            <div class="col-md-2">
              <button type="submit" class="btn btn-primary btn-block" :disabled="isLoadingList">
                <span v-if="isLoadingList" class="spinner-border spinner-border-sm mr-1"></span>
                <i v-else class="fa fa-filter mr-1"></i> Lọc
              </button>
            </div>
          </form>
        </div>
      </div>

      <div class="card">
        <div class="card-body p-0">
          <div v-if="isLoadingList && items.length === 0" class="p-4 text-center"> <div class="spinner-border text-primary" role="status"></div><p class="mt-2 mb-0 text-muted">Đang tải lịch sử...</p></div>
          <div v-else-if="listError && items.length === 0" class="alert alert-danger m-3"><i class="fa fa-exclamation-triangle mr-2"></i> {{ listError }}<button class="btn btn-sm btn-danger ml-2" @click="fetchList">Thử lại</button></div>
          <div v-else-if="items.length === 0" class="p-4 text-center text-muted">Không tìm thấy lịch sử checklist nào khớp điều kiện.</div>
          
          <div v-else class="table-responsive">
            <table class="table table-hover table-striped mb-0">
              <thead class="thead-light">
                <tr>
                  <th>Thời gian</th>
                  <th>Tài xế</th>
                  <th>Biển số Xe</th>
                  <th>Số ODO</th>
                  <th>Kết quả</th>
                  <th>Lỗi nghiêm trọng</th>
                  <th class="text-right">Chi tiết</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="log in items" :key="log.id" @click="openDetail(log.id)" style="cursor: pointer;">
                  <td>{{ formatDateTime(log.thoiDiemThucHien) }}</td>
                  <td>{{ log.tenTaiXe || 'N/A' }}</td>
                  <td><strong>{{ log.xeBienSo || 'N/A' }}</strong></td>
                  <td>{{ log.odo || '-' }} km</td>
                  <td>
                    <span v-if="log.soItemNG > 0" class="badge badge-danger">Có {{ log.soItemNG }} lỗi</span>
                    <span v-else class="badge badge-success">OK</span>
                  </td>
                  <td>
                      <span v-if="log.hasCriticalError" class="text-danger font-weight-bold"><i class="fa fa-exclamation-triangle mr-1"></i> CÓ</span>
                      <span v-else class="text-success">Không</span>
                  </td>
                  <td class="text-right">
                    <button class="btn btn-sm btn-outline-primary" @click.stop="openDetail(log.id)">
                      <i class="fa fa-eye"></i> Xem
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          
           <div v-if="totalPages > 1" class="p-3 d-flex justify-content-between align-items-center border-top">
            <small class="text-muted">Tổng: {{ totalElements }} bản ghi — Trang {{ currentPage }}/{{ totalPages }}</small>
            <ul class="pagination pagination-sm mb-0">
              <li class="page-item" :class="{ disabled: currentPage === 1 }"><a href="#" class="page-link" @click.prevent="goPage(currentPage - 1)">Trước</a></li>
              <li v-for="p in totalPages" :key="p" class="page-item" :class="{ active: p === currentPage }"><a href="#" class="page-link" @click.prevent="goPage(p)">{{ p }}</a></li>
              <li class="page-item" :class="{ disabled: currentPage === totalPages }"><a href="#" class="page-link" @click.prevent="goPage(currentPage + 1)">Sau</a></li>
            </ul>
          </div>
        </div>
      </div>

      <div v-if="showModal" class="modal fade show d-block" tabindex="-1" style="background: rgba(0,0,0,.5);">
          <div class="modal-dialog modal-xl" role="document"> 
            <div class="modal-content">
                <div class="modal-header bg-light">
                   <h5 class="modal-title font-weight-bold" v-if="currentLogDetail">
                     <i class="fa fa-clipboard-check mr-2"></i> Chi tiết Checklist #{{ currentLogDetail.log.id }}
                   </h5>
                   <h5 v-else class="modal-title font-weight-bold">Đang tải...</h5>
                   <button type="button" class="close" @click="closeModal"><span>&times;</span></button>
                </div>
                
                <div v-if="isLoadingDetail" class="modal-body text-center py-5">
                    <div class="spinner-border text-primary" style="width: 3rem; height: 3rem;"></div>
                    <p class="mt-3 text-muted">Đang tải chi tiết...</p>
                </div>
                 <div v-else-if="detailError" class="modal-body">
                    <div class="alert alert-danger">{{ detailError }}</div>
                </div>
                
                <div v-else-if="currentLogDetail" class="modal-body">
                   <div class="row mb-3">
                       <div class="col-md-4"><strong>Xe:</strong> {{ currentLogDetail.log.xeBienSo }}</div>
                       <div class="col-md-4"><strong>Tài xế:</strong> {{ currentLogDetail.log.tenTaiXe }}</div>
                       <div class="col-md-4"><strong>Thời gian:</strong> {{ formatDateTime(currentLogDetail.log.thoiDiemThucHien) }}</div>
                       <div class="col-md-4"><strong>ODO:</strong> {{ currentLogDetail.log.odo }} km</div>
                       <div class="col-md-4">
                           <strong>Kết quả:</strong>
                           <span v-if="currentLogDetail.log.soItemNG > 0" class="badge badge-danger">Có {{ currentLogDetail.log.soItemNG }} lỗi</span>
                           <span v-else class="badge badge-success">OK</span>
                       </div>
                   </div>
                   
                   <h6 class="font-weight-bold">Chi tiết hạng mục:</h6>
                   <div class="table-responsive" style="max-height: 60vh; overflow-y: auto;">
                       <table class="table table-sm table-bordered">
                           <thead class="thead-light">
                               <tr>
                                   <th style="width: 50px;">TT</th>
                                   <th>Hạng mục</th>
                                   <th style="width: 100px;">Trạng thái</th>
                                   <th>Ghi chú</th>
                                   <th style="width: 200px;">Hình ảnh</th>
                               </tr>
                           </thead>
                           <tbody>
                               <tr v-for="(item, index) in currentLogDetail.items" :key="item.id" 
                                   :class="{ 'table-danger': item.trangThai === 'NG' && (item.mucDo === 'CRITICAL'), 'table-warning': item.trangThai === 'NG' && (item.mucDo === 'WARNING') }">
                                   <td>{{ index + 1 }}</td>
                                   <td>
                                       <strong>{{ item.tenHangMuc }}</strong>
                                       <span v-if="item.mucDo" :class="['badge', 'ml-2', getMucDoBadge(item.mucDo)]">{{ item.mucDo }}</span>
                                   </td>
                                   <td class="text-center">
                                       <span v-if="item.trangThai === 'OK'" class="badge badge-success">OK</span>
                                       <span v-else class="badge badge-danger">LỖI (NG)</span>
                                   </td>
                                   <td>{{ item.ghiChu || '-' }}</td>
                                   
                                   <td class="text-center">
                                     <div v-if="item.anhUrls && item.anhUrls.length > 0" class="d-flex flex-wrap gap-1 justify-content-center">
                                        <div 
                                          v-for="(url, idx) in item.anhUrls" 
                                          :key="idx"
                                          class="img-thumb-wrapper"
                                          @click="showLightbox(item.anhUrls, idx)"
                                        >
                                            <img :src="url" loading="lazy" />
                                            </div>
                                     </div>
                                     
                                     <div v-else-if="item.anhUrl">
                                        <div class="img-thumb-wrapper" @click="showLightbox([item.anhUrl], 0)">
                                            <img :src="item.anhUrl" loading="lazy" />
                                        </div>
                                     </div>
                                     
                                     <span v-else class="text-muted small">-</span>
                                   </td>

                               </tr>
                           </tbody>
                       </table>
                   </div>
                </div>
                 <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="closeModal">Đóng</button>
                 </div>
            </div>
          </div>
      </div>

      <VueEasyLightbox
        :visible="lightbox.visible"
        :imgs="lightbox.imgs"
        :index="lightbox.index"
        @hide="handleHideLightbox"
      />

    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'pinia';
import { useAdminChecklistStore } from '@/stores/adminXeChecklistStore';
import VueEasyLightbox from "vue-easy-lightbox"; // [IMPORT]

// --- Helpers Format ---
function pad2(n) { return String(n).padStart(2, '0'); }
function parseIsoLocal(s) {
    if (!s) return null;
    if (s instanceof Date) return s;
    const m = String(s).match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})/);
    if (!m) return null;
    const [, y, M, d, h, mi, se] = m;
    return new Date(+y, +M - 1, +d, +h, +mi, +se);
}
function formatDate(s) {
    const d = parseIsoLocal(s);
    if (!d) return '-';
    const dd = pad2(d.getDate());
    const MM = pad2(d.getMonth() + 1);
    const yyyy = d.getFullYear();
    return `${dd}/${MM}/${yyyy}`;
}
function formatDateTime(s) {
    const d = parseIsoLocal(s);
    if (!d) return '-';
    const dd = pad2(d.getDate());
    const MM = pad2(d.getMonth() + 1);
    const yyyy = d.getFullYear();
    const hh = pad2(d.getHours());
    const mm = pad2(d.getMinutes());
    return `${dd}/${MM}/${yyyy} ${hh}:${mm}`;
}

export default {
  name: 'QuanLyChecklistLog',
  components: {
    VueEasyLightbox // [REGISTER]
  },
  data() {
    return {
      filters: {
          xeId: null,
          taiXeId: null,
          hasError: null,
      },
      showModal: false,
      
      // [STATE] Lightbox
      lightbox: {
        visible: false,
        imgs: [],
        index: 0
      }
    };
  },
  computed: {
    ...mapState(useAdminChecklistStore, [
      'isLoadingList', 'listError', 'items', 'totalPages', 'totalElements', 'size', 'page',
      'filterXeId', 'filterTaiXeId', 'filterHasError',
      'isLoadingDetail', 'detailError', 'currentLogDetail',
      'isLoadingOptions', 'xeOptions', 'taiXeOptions',
    ]),
    ...mapGetters(useAdminChecklistStore, ['currentPage']),

    pageSize: {
      get() { return this.size; },
      set(v) { /* handled in changeSize */ }
    }
  },
  methods: {
    ...mapActions(useAdminChecklistStore, [
      'fetchList', 'setPage', 'setSize', 'setFiltersAndFetch', 
      'fetchOptionsIfNeeded', 'fetchLogDetail', 'clearLogDetail',
    ]),

    formatDate,
    formatDateTime,
    getMucDoBadge(mucDo) {
        switch (mucDo) {
            case 'CRITICAL': return 'badge-danger';
            case 'WARNING': return 'badge-warning';
            case 'INFO': return 'badge-info';
            default: return 'badge-light';
        }
    },

    applyFilters() { this.setFiltersAndFetch(this.filters); },
    changeSize() { this.setSize(Number(this.pageSize)); this.fetchList(); },
    goPage(p) {
        if (p < 1 || p > this.totalPages || p === this.currentPage) return;
        this.setPage(p);
        this.fetchList();
    },

    async openDetail(logId) {
        this.showModal = true;
        document.body.style.overflow = 'hidden';
        await this.fetchLogDetail(logId);
    },
    closeModal() {
        this.showModal = false;
        this.clearLogDetail();
        document.body.style.overflow = '';
    },

    // [METHOD] Lightbox Logic
    showLightbox(images, index) {
      // images có thể là mảng string URL
      this.lightbox.imgs = images; 
      this.lightbox.index = index;
      this.lightbox.visible = true;
    },
    handleHideLightbox() {
      this.lightbox.visible = false;
    }
  },

  mounted() {
    this.filters.xeId = this.filterXeId;
    this.filters.taiXeId = this.filterTaiXeId;
    this.filters.hasError = this.filterHasError;
    
    this.fetchList();
    this.fetchOptionsIfNeeded();
  }
};
</script>

<style scoped>
/* Style chung */
.card { box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075); }
.table td, .table th { vertical-align: middle; }
.table thead th { background-color: #e9ecef; border-bottom-width: 1px; }
.table-hover tbody tr:hover { background-color: #f8f9fa; }

/* Modal */
.modal { overflow-y: auto; }
body.modal-open { overflow: hidden !important; padding-right: 0 !important; }
.modal-body { max-height: 85vh; overflow-y: auto; }

/* Badge */
.badge { padding: 0.4em 0.6em; font-size: 0.8rem; }
.badge-success { background-color: #198754; color: #fff;}
.badge-danger    { background-color: #dc3545; color: #fff;}
.badge-warning { background-color: #ffc107; color: #000; }
.badge-info { background-color: #0dcaf0; color: #000; }
.badge-light { background-color: #f8f9fa; color: #6c757d; border: 1px solid #dee2e6; }

/* Table Warning/Critical Row */
.table-danger, .table-danger > th, .table-danger > td { background-color: #f8d7da !important; color: #721c24; }
.table-warning, .table-warning > th, .table-warning > td { background-color: #fff3cd !important; color: #856404; }

.card-body .form-label { font-size: 0.85rem; font-weight: 500; margin-bottom: 0.25rem; }

/* [NEW] Style ảnh thumbnail cho Lightbox */
.gap-1 { gap: 0.25rem; }

.img-thumb-wrapper {
    width: 60px;
    height: 60px;
    border-radius: 4px;
    border: 1px solid #dee2e6;
    overflow: hidden;
    cursor: pointer;
    transition: transform 0.1s;
}
.img-thumb-wrapper img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.img-thumb-wrapper:hover {
    transform: scale(1.05);
    border-color: #0d6efd;
}
</style>